import { Checkbox } from '@zoopla-eng/zds/checkbox';
import { Stack } from '@zoopla-eng/zds/stack';
import { getPropertyType } from '@zoopla/listing-search/get-property-type';
import { itemStyle } from './PropertyType.styles.css';

const propertyTypes = ['property', 'houses', 'flats', 'farms_land'] as const;

const propertySubTypes = [
    'detached',
    'semi_detached',
    'terraced',
    'flats',
    'bungalow',
    'farms_land',
    'park_home'
] as const;

const propertySubTypeLabels = {
    detached: 'Detached',
    semi_detached: 'Semi-detached',
    terraced: 'Terraced',
    flats: 'Flats',
    bungalow: 'Bungalows',
    farms_land: 'Farms/land',
    park_home: 'Park homes'
};

export type PropertyType = typeof propertyTypes[number];
export type PropertySubType = Array<typeof propertySubTypes[number]>;

type PropertyTypeCheckboxesProps = {
    value: { propertyType: PropertyType; propertySubType: PropertySubType };
    onChange: ({
        propertySubType,
        propertyType
    }: {
        propertySubType: PropertySubType;
        propertyType: PropertyType;
    }) => void;
};

export const PropertyTypeCheckboxes = ({
    value,
    onChange
}: PropertyTypeCheckboxesProps) => {
    return (
        <Stack flexDirection="row" flexWrap="wrap" columnGap={0} rowGap="S400">
            {[
                <div key="show-all" className={itemStyle}>
                    <Checkbox
                        key="quicksearch_show_all"
                        name="show_all"
                        label="Show all"
                        checked={value.propertySubType.length === 0}
                        onCheckedChange={() => {
                            onChange({
                                propertySubType: [],
                                propertyType: 'property'
                            });
                        }}
                    />
                </div>,
                ...propertySubTypes.map((propertySubType) => {
                    return (
                        <div key={propertySubType} className={itemStyle}>
                            <Checkbox
                                key={`quicksearch_${propertySubType}`}
                                name={propertySubType}
                                label={propertySubTypeLabels[propertySubType]}
                                checked={value.propertySubType.includes(
                                    propertySubType
                                )}
                                onCheckedChange={(checked) => {
                                    if (checked) {
                                        const _propertySubType = [
                                            ...value.propertySubType,
                                            propertySubType
                                        ];

                                        onChange({
                                            propertySubType: _propertySubType,
                                            propertyType:
                                                getPropertyType(
                                                    _propertySubType
                                                )
                                        });
                                    } else {
                                        const _propertySubType =
                                            value.propertySubType.filter(
                                                (i) => i !== propertySubType
                                            );

                                        onChange({
                                            propertySubType: _propertySubType,
                                            propertyType:
                                                getPropertyType(
                                                    _propertySubType
                                                )
                                        });
                                    }
                                }}
                            />
                        </div>
                    );
                })
            ]}
        </Stack>
    );
};
